export const ConversationTips = {
  A: {
    high: 'Give %name% space to introduce and drive ideas',
    low: 'Encourage and support %name%’s ideas',
    situational: 'Ask %name% where they want to start',
  },
  B: {
    high: 'Allow time for casual conversation',
    low: 'Allow time to think things through',
    situational: 'Ask %name% if they want to reflect or talk things out',
  },
  C: {
    high: 'Give each topic its dedicated time',
    low: 'Adapt the agenda as needed',
    situational: 'Let %name% determine the flow of topics',
  },
  D: {
    high: 'Set clear next steps and explain the “why”',
    low: 'Keep the agenda flexible, but recap takeaways',
    situational: 'Set expectations, but let %name% navigate the path forward',
  },
};

export const getConversationTip = ({ factor, sigmaZone }: { factor: string; sigmaZone: number }) => {
  if (sigmaZone > 0) return ConversationTips[factor.toUpperCase()]['high'];
  else if (sigmaZone < 0) return ConversationTips[factor]['low'];
  return ConversationTips[factor]['situational'];
};
